import React from "react";

function ProblemSection() {
  return (
    <section className="section problem-section" id="problem">
      <div className="container">
        <div className="section-header" data-aos="fade-up">
          <h2>
            Your business is already generating real-time data. The problem is:
            your architecture isn't.
          </h2>
        </div>

        <div className="problem-grid">
          <div className="problem-card" data-aos="fade-up" data-aos-delay="100">
            <div className="icon">
              <i className="fas fa-clock"></i>
            </div>
            <h3>Batch is Too Slow</h3>
            <p>
              Overnight batch reports cannot stop fraud happening right now. By
              the time you see it, the damage is done.
            </p>
          </div>

          <div className="problem-card" data-aos="fade-up" data-aos-delay="150">
            <div className="icon">
              <i className="fas fa-project-diagram"></i>
            </div>
            <h3>Data Silos</h3>
            <p>
              SIEMs miss critical context because log data and transaction data
              live in separate universes.
            </p>
          </div>

          <div className="problem-card" data-aos="fade-up" data-aos-delay="200">
            <div className="icon">
              <i className="fas fa-tachometer-alt"></i>
            </div>
            <h3>Scale Challenges</h3>
            <p>
              Core systems can't keep up with API traffic spikes, payment
              bursts, or login storms.
            </p>
          </div>

          <div className="problem-card" data-aos="fade-up" data-aos-delay="250">
            <div className="icon">
              <i className="fas fa-shield-alt"></i>
            </div>
            <h3>Compliance Pressure</h3>
            <p>
              Regulators now expect near-real-time visibility and audit trails,
              not yesterday's reports.
            </p>
          </div>
        </div>

        <div className="callout-box" data-aos="fade-up">
          <p>
            Confluent + iValue turns data-in-motion into a shared, governed,
            reusable streaming backbone for the entire enterprise — not just
            another 'integration project'.
          </p>
        </div>
      </div>
    </section>
  );
}

export default ProblemSection;
